import { render, staticRenderFns } from "./LeaderboardBreakdownModal.vue?vue&type=template&id=3ba6b169&scoped=true&"
import script from "./LeaderboardBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./LeaderboardBreakdownModal.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardBreakdownModal.vue?vue&type=style&index=0&id=3ba6b169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6b169",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba6b169')) {
      api.createRecord('3ba6b169', component.options)
    } else {
      api.reload('3ba6b169', component.options)
    }
    module.hot.accept("./LeaderboardBreakdownModal.vue?vue&type=template&id=3ba6b169&scoped=true&", function () {
      api.rerender('3ba6b169', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LeaderboardBreakdownModal.vue"
export default component.exports